/* global google */
export default class DropDownControl {

    constructor(wrapper){
        this.wrapper=wrapper;
        this.firstEntry = true;
    }

    optionDiv(options) {
        var control = document.createElement('DIV');
        control.className = "mapDropDownItemDiv";
        control.title = options.title;
        control.wrapper = options.wrapper;
        control.id = options.id;
        control.innerHTML = options.name;
        google.maps.event.addDomListener(control, 'click', options.action);
        return control;
    }

    static getElementById(wrapper_id,id){
        let el=document.querySelectorAll('#'+wrapper_id+' #'+id);
        return (el.length>0)?el[0]:null;
    }

    static getElementsByClass(wrapper_id,className){
        let el=document.querySelectorAll('#'+wrapper_id+' .'+className);
        return el;
    }

    checkBox(options) {

        //first make the outer container
        var container = document.createElement('DIV');
        container.className = "mapCheckboxContainer";
        container.title = options.title;
        container.wrapper = options.wrapper;

        var span = document.createElement('SPAN');
        span.role = "checkbox";
        span.className = "mapCheckboxSpan";

        var bDiv = document.createElement('DIV');
        bDiv.className = "mapBlankDiv";
        bDiv.id = options.id;

        var image = document.createElement('IMG');
        image.className = "mapBlankImg";
        image.src = "https://maps.gstatic.com/mapfiles/mv/imgs8.png";

        var label = document.createElement('LABEL');
        label.className = "mapCheckboxLabel";
        label.innerHTML = options.label;

        bDiv.appendChild(image);
        span.appendChild(bDiv);
        container.appendChild(span);
        container.appendChild(label);

        if (options.checked) {
            bDiv.style.display = 'block';
            options.action(options, true);
        }
        var context=this;
        google.maps.event.addDomListener(container, 'click', ()=>{
            let el=DropDownControl.getElementById(context.wrapper,bDiv.id);
            if(el){
                let selected = (el.style.display == 'block');
                selected ? el.style.display = 'none' : el.style.display = 'block';
                var isSelected = !selected;

                DropDownControl.selectCheckBox(this.wrapper,bDiv.id, isSelected);
                options.action(options, isSelected);
            }
        });
        return container;
    }
    separator() {
        var sep = document.createElement('DIV');
        sep.className = "mapSeparatorDiv";
        return sep;
    }

    static selectCheckBox(wrapper,id, isSelected) {

        var elems = DropDownControl.getElementsByClass(wrapper,'mapCheckboxContainer');
        var i = 0;

        if (typeof (elems) !== "object") {
            return;
        }

        for (i = 0; i < elems.length; i++) {
            elems[i].className = elems[i].className.replace("mapCheckboxIsSelected", '');
        }

        if (isSelected) {
            //Select parent with class mapCheckboxContainer
            let el=DropDownControl.getElementById(id);
            if(el){
                el.parentElement.parentElement.className += " mapCheckboxIsSelected";
            }
        }
    }

    loadingMask(id, html) {
        
        let loadingMask=DropDownControl.getElementById(this.wrapper,id);
        if (null == loadingMask) {
            loadingMask = document.createElement('DIV');
            loadingMask.className = "maploadingMaskDiv";
            loadingMask.id = id;
        }

        loadingMask.innerHTML = html;

        return loadingMask;
    }

    hideById(id) {
        let el=DropDownControl.getElementById(this.wrapper,id);
        if(el){
            el.style.display = 'none';
        }
    }
    showById(id) {
        let el=DropDownControl.getElementById(this.wrapper,id);
        if(el){
            el.style.display = 'block';
        }
    }

    clearDropDownItems (dropDownWrapperId) {
        
        let container =DropDownControl.getElementById(this.wrapper,dropDownWrapperId);
        if (null != container && container != "undefined") {
            container.innerHTML = "";
        }
    }

    dropDownOptionsDiv (options) {
        
        let container =DropDownControl.getElementById(this.wrapper,options.id);
        if (null==container){
            container = document.createElement('DIV');
            container.className = "mapDropDownOptionsDiv";
            container.id = options.id;
        }

        for (var i = 0; i < options.items.length; i++) {
            container.appendChild(options.items[i]);
        }

        return container;
    }

    initDropDownControl (options, id, onEmptyClb, setMapsVisible,setBoxInvisible=false) {
        var hideDropBox = false;
        var container = document.createElement('DIV');
        container.className = 'mapContainer';

        var control = document.createElement('DIV');
        let invisble=(setBoxInvisible)?'d-none':'';
        control.className = `mapDropDownControl ${invisble}`;
        control.innerHTML = options.name;
        control.id = options.name;
        var arrow = document.createElement('IMG');
        arrow.src = "https://maps.gstatic.com/mapfiles/arrow-down.png";
        arrow.className = 'mapDropDownArrow';
        control.appendChild(arrow);
        container.appendChild(control);
        container.appendChild(options.dropDown);

        if(options.gmap){
            options.gmap.controls[options.position].push(container);
        }

        var context=this;
        google.maps.event.addDomListener(container, 'mouseover', function() {
            if (context.firstEntry) {
                if (typeof (onEmptyClb) === "function") {
                    onEmptyClb(setMapsVisible);
                }
            }
            hideDropBox = false;
            context.firstEntry = false;

            let el =DropDownControl.getElementById(context.wrapper,id);
            if (el && el.style.display !== 'block') {
                el.style.display = 'block';
            }
        });
        google.maps.event.addDomListener(container, 'mouseout', function() {
            hideDropBox = true;
            var el =DropDownControl.getElementById(context.wrapper,id);
            setTimeout(function() {
                if (el && hideDropBox) {
                    el.style.display = 'none';
                }
            }, 1000);
        });
    }

    reset () {
        this.firstEntry = true;
    }

    buttonControl (options) {
        var control = document.createElement('DIV');
        control.innerHTML = options.name;
        control.className = 'mapButton';
        control.index = 1;

        // Add the control to the map
        options.gmap.controls[options.position].push(control);

        // When the button is clicked pan to ...
        google.maps.event.addDomListener(control, 'click', options.action);
        return control;
    }
}